<template>
  <div class="page page-watch">
    <div class="split-container">
      <OLMap ref="map" class="map-container" />
      <MapRightPanel id="map-panel" class="menu-container" @findCar="$refs.map.findCarOnMap()" />
    </div>
  </div>
</template>

<script>
import OLMap from '@/components/maps/OLMap'
import MapRightPanel from '@/components/maps/MapRightPanel'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Watch',
  components: {
    OLMap,
    MapRightPanel
  },
  props: {
    carId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState('taxi/mapCars', {
      cars: state => state.items.filter(car => car.imei),
      isLoading: state => state.isLoading
    })
  },
  watch: {
    carId: {
      immediate: true,
      handler (carId) {
        if (carId == undefined) {
          this.selectCar(null)
        } else {
          this.selectCar(parseInt(carId))
        }
      }
    }
  },
  beforeDestroy () {
    clearTimeout(this._timeout)
    this._timeout = null
  },
  mounted () {
    if (!this._timeout) {
      this.startWatch()
    }
    this.setTitle([
      {
        title: 'Наблюдение',
        url: '/watch'
      },
      {
        title: 'Карта'
      }
    ])
  },
  methods: {
    ...mapActions('taxi/mapCars', [
      'getCarsForWatch',
      'abortLoading',
      'selectCar'
    ]),
    startWatch () {
      if (!this.isLoading) {
        this.getCarsForWatch()
      }
      this._timeout = setTimeout(() => { this.startWatch() }, 4000)
    },
    ...mapActions('taxi', [
      'setTitle'
    ])
  }
}
</script>

<style scoped>
  .page-watch {
    height: 100%;
    padding: 0;
  }
  .split-container {
    display: flex;
    height: 100%;
  }
  .map-container {
    flex-grow: 1;
  }
  .menu-container {
    width: 500px;
    overflow-y: scroll;
  }
  @media screen and (max-width: 768px) {
    .split-container {
      display: block;
      overflow-y: scroll;
    }
    .map-container {
      height: 500px;
    }
    .menu-container {
      width: 100%;
      overflow-y: hidden;
    }
  }
</style>
